import React, { Component } from 'react';
import imag from "../static/images/wip.gif"

class Wip extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount(){

    }

    render() {

        return (
            <div>
               <h1>Work in progress</h1>
               <img alt="" src={imag}></img>
            </div>


        );
    }

}

export default Wip;
